// Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import base64 from 'crypto-js/enc-base64';
import utf8 from 'crypto-js/enc-utf8';

// Primereact imports
import { TieredMenu } from 'primereact/tieredmenu';
import { SlideMenu } from 'primereact/slidemenu';
import { Badge } from 'primereact/badge';
import { Toast } from 'primereact/toast';

// Styling
import './menu-header.scss';
import CaretDownIcon from "../../assets/icons/caret-down.svg";

// Redux
import { connect } from 'react-redux';
import BrainAnswerService from '../../redux/services/brain-answer';
import CmsService from '../../redux/services/cms';
import SignatureService from '../../redux/services/signature';
import { renderWebsitePage, setWebsiteMenus } from '../../redux/actions/app';

// Utils
import { REGISTRATION_STATE_SUSPENDED } from '../../common/constants';
import { isMobileOnly, isTablet } from 'react-device-detect';
import { checkPublicPage } from '../../common/utils/page-utils';

// Multi lang
import { withTranslation } from 'react-multi-lang';

class MenuHeader extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
        };
    }

    componentDidMount() {
        // Read WP menus from server
        this.loadWebsiteMenus(this.props.language);
    }

    componentDidUpdate(prevProps) {
        if (this.props.language !== prevProps.language) {
            // Read WP menus from server
            this.loadWebsiteMenus(this.props.language);
        }
    }

    loadWebsiteMenus(language) {
        CmsService.getMenus(language, this.props.associate !== null)
        .then((response) => {
            if(response.errorMessage === null) {
                this.props.setWebsiteMenus(this.buildMenuStructure(response.menu.items))
            }
            else {
                this._toast.current.show({ severity: 'error', detail: this.props.t("general.error-message"), life: 5000 }); 
            }
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("general.error-message"), life: 5000 });
        });
    }

    buildMenuStructure(menuItems) {
        let index = 1;
        let menus = [];

        for (let i = 0; i < menuItems.length; i++) {

            let menu = menuItems[i].children === null || menuItems[i].children.length === 0 ?
                {
                    title: menuItems[i].title,
                    label: menuItems[i].title,
                    itemUrl: menuItems[i].url,
                    command: ()=>{ this.renderWebsitePage(menuItems[i].url) }
                }
                : 
                {
                    id: index,
                    title: menuItems[i].title,
                    label: menuItems[i].title,
                    ref: React.createRef(),
                    items: this.buildMenuStructure(menuItems[i].children)
                };

            menus.push(menu);

            index++;
        }

        return menus;
    }

    accessBrainAnswerPlatform() {
        BrainAnswerService.getBrainAnswerAccessUrl(this.props.associate.associateId)
        .then((response) => {
            if(response.errorMessage === null) {
                window.open(response.url,"_blank");
            }
            else {
                this._toast.current.show({ severity: 'error', detail: this.props.t("general.error-message"), life: 5000 }); 
            }
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("general.error-message"), life: 5000 });
        });
    }

    accessSignaturePlatform() {
        SignatureService.getSignatureAppAccessUrl(this.props.ballot.ballotRef)
        .then((response) => {
            if(response.errorMessage === null) {
                window.open(response.url,"_blank");
            }
            else {
                this._toast.current.show({ severity: 'error', detail: this.props.t("general.error-message"), life: 5000 }); 
            }
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("general.error-message"), life: 5000 });
        });
    }

    renderWebsitePage(url) {
        if(!url.includes("wp-content") && !url.includes("https://ordemdosfisioterapeutas.pt")) {
            window.open(process.env.PUBLIC_URL + "/" + url, "_self");
        }
        else if(url.includes("wp-content") || !url.includes("https://ordemdosfisioterapeutas.pt")) {
            window.open(url, "_blank");
        }
        else if (url.includes("https://ordemdosfisioterapeutas.pt")) {
            this.props.renderWebsitePage(url + "?hideinar=true");
            window.open(process.env.PUBLIC_URL + "/", "_self");
        }
    }  

    clearMenus(target, menuId) {
        for (let i = 0; i < this.props.menus.length; i++) {
            if(this.props.menus[i].id !== menuId) {
                this.props.menus[i].ref.hide(target)
            }
        }

        this.menu.hide(target);
    }

    getMobileMemberAreaMenus() {
        // Build member area menu according to different permissions on logged and approved users
        let memberAreaItems = [];

        for (let i = 0; i < this.props.menus.length; i++) {
            memberAreaItems.push(this.props.menus[i]);
        }
        
        memberAreaItems.push({
            label: this.props.t("dashboard.menu").toUpperCase(),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/dashboard", "_self"); }  
        });

        memberAreaItems.push({
            label: this.props.t("profile.menu").toUpperCase(),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/profile", "_self"); }  
        });

        memberAreaItems.push({
            label: this.props.t("support.menu").toUpperCase(),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/support", "_self"); }  
        });

        memberAreaItems.push({
            label: this.props.t("payments.menu").toUpperCase(),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/payments", "_self"); }  
        });

        memberAreaItems.push({
            label: this.props.t("quotes.menu").toUpperCase(),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/quotes", "_self"); }  
        });

        memberAreaItems.push({
            label: this.props.t("products.menu").toUpperCase(),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/products", "_self"); }  
        });

        if(this.props.brainAnswerAccess && this.props.registrationApproved && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED) {
            memberAreaItems.push({
                label: this.props.t("brain-answer.menu").toUpperCase(),
                command:()=>{ this.accessBrainAnswerPlatform(); }  
            });
        }

        if(this.props.registrationApproved && this.props.organicUnits !== undefined && this.props.organicUnits !== null && this.props.organicUnits.length > 0) {
            memberAreaItems.push({
                label: this.props.t("allowances.title").toUpperCase(),
                command:()=>{ window.open(process.env.PUBLIC_URL + "/allowances", "_self"); }  
            });
        }

        memberAreaItems.push({
            label: this.props.t("trainings.menu").toUpperCase(),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/trainings", "_self"); }  
        });

        memberAreaItems.push({
            label: this.props.t("congresses.menu").toUpperCase(),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/congressos", "_self"); }  
        });

        if(process.env.REACT_APP_ENVIRONMENT === "QA") {
            memberAreaItems.push({
                label: this.props.t("portal-emprego.menu").toUpperCase(),
                command:()=>{ window.open(process.env.PUBLIC_URL + "/portal-emprego", "_self"); } 
            });
        }

        memberAreaItems.push({
            label: this.props.t("questionario.menu").toUpperCase(),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/questionario", "_self"); } 
        });

        if(this.props.registrationApproved && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED) {
            memberAreaItems.push({
                label: this.props.t("comissao-instaladora.menu").toUpperCase(),
                command:()=>{ window.open(process.env.PUBLIC_URL + "/comissao-instaladora", "_self"); } 
            });
        }

        return memberAreaItems;
    }

    getNonApprovedMobileItems() {
        let memberAreaItems = [];

        let nonRegisteredItems = [
            {
                label: this.props.t("communication.menu").toUpperCase(),
                command:()=>{ window.open(process.env.PUBLIC_URL + "/communication", "_self"); }  
            },
            {
                label: this.props.t("payments.menu").toUpperCase(),
                command:()=>{ window.open(process.env.PUBLIC_URL + "/payments", "_self"); }  
            }
        ];

        for (let i = 0; i < this.props.menus.length; i++) {
            memberAreaItems.push(this.props.menus[i]);
        }

        memberAreaItems.push({
            label: this.props.t("general.registration").toUpperCase(),
            items: nonRegisteredItems
        });

        memberAreaItems.push({
            label: this.props.t("support.menu").toUpperCase(),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/support", "_self"); }  
        });

        return memberAreaItems;
    }

    getTotalBasketItems() {
        return (Number(this.props.basketProducts.length) + Number(this.props.basketTrainings.length)).toString();
    }

  render() {

    // Build member area menu according to different permissions on logged and approved users
    let memberAreaItems = [
        {
            label: this.props.t("dashboard.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/dashboard", "_self"); }  
        },
        {
            label: this.props.t("profile.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/profile", "_self"); }  
        },
        {
            label: this.props.t("support.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/support", "_self"); }  
        },
        {
            label: this.props.t("payments.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/payments", "_self"); }  
        },
        {
            label: this.props.t("quotes.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/quotes", "_self"); }  
        },
        {
            label: this.props.t("products.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/products", "_self"); }  
        }
    ];

    if(this.props.brainAnswerAccess && this.props.registrationApproved && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED) {
        memberAreaItems.push({
            label: this.props.t("brain-answer.menu"),
            command:()=>{ this.accessBrainAnswerPlatform(); }  
        });
    }

    if(this.props.registrationApproved && this.props.organicUnits !== undefined && this.props.organicUnits !== null && this.props.organicUnits.length > 0) {
        memberAreaItems.push({
            label: this.props.t("allowances.title"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/allowances", "_self"); }  
        });
    }

    memberAreaItems.push({
        label: this.props.t("trainings.menu"),
        command:()=>{ window.open(process.env.PUBLIC_URL + "/trainings", "_self"); }  
    });

    memberAreaItems.push({
        label: this.props.t("congresses.menu"),
        command:()=>{ window.open(process.env.PUBLIC_URL + "/congressos", "_self"); } 
    });

    if(process.env.REACT_APP_ENVIRONMENT === "QA") {
        memberAreaItems.push({
            label: this.props.t("portal-emprego.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/portal-emprego", "_self"); } 
        });
    }

    memberAreaItems.push({
        label: this.props.t("questionario.menu"),
        command:()=>{ window.open(process.env.PUBLIC_URL + "/questionario", "_self"); } 
    });

    if(this.props.registrationApproved && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED) {
        memberAreaItems.push({
            label: this.props.t("comissao-instaladora.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/comissao-instaladora", "_self"); } 
        });
    }

    // Build member area menu according to different permissions on non approved users
    let nonRegisteredItems = [
        {
            label: this.props.t("communication.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/communication", "_self"); }  
        },
        {
            label: this.props.t("payments.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/payments", "_self"); }  
        }
    ];

    // Build member area menu for internal users
    let internalItems = [
        {
            label: this.props.t("allowances.title"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/allowances", "_self"); }  
        }
    ];

    if(isTablet || isMobileOnly) {
        internalItems.push({
            label: this.props.t("support.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/support", "_self"); }  
        });
    }

    let nonApprovedMobileItems = [
        /*{
            label: this.props.t("registration-form.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/registration-form", "_self"); }  
        },*/
        {
            label: this.props.t("general.registration"),
            items: nonRegisteredItems
         },
         {
            label: this.props.t("support.menu"),
            command:()=>{ window.open(process.env.PUBLIC_URL + "/support", "_self"); }  
         }
    ];

    return (
        checkPublicPage(window.location.href) === false ?
            <div className="grid mgt-10" style={{height: (isTablet || isMobileOnly) ? null : "93px", maxHeight: (isTablet || isMobileOnly) ? "70px" : "93px", alignItems:"center", background: "#FFFFFF"}}>
                {
                    !isMobileOnly && !isTablet && this.props.registrationApproved && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED ?
                    this.props.menus && this.props.menus.map((menu) => { 
                            return <TieredMenu model={menu.items} 
                                            onMouseLeave={(target) => menu.ref.hide(target)}
                                            popup ref={el => menu.ref = el} 
                                            id={"overlay_tmenu-" + menu.id} 
                                            style={{width: "250px", marginTop: "15px", fontSize: "13px", fontWeight: "600", lineHeight: "2em"}} />;
                        })
                        :
                        null
                }
                {
                    !isMobileOnly && !isTablet && this.props.registrationApproved && this.props.userId !== null && this.props.associate !== null && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED ?
                        <TieredMenu model={memberAreaItems} popup ref={el => this.menu = el} id="overlay_tmenu" onMouseLeave={(target) => this.menu.hide(target)} style={{width: "250px", marginTop: "15px", fontSize: "13px", fontWeight: "600", lineHeight: "2em"}} />
                        :
                        null
                }
                {
                    !isMobileOnly && !isTablet && this.props.userId !== null && this.props.associate !== null && !this.props.registrationApproved ?
                        <TieredMenu model={nonRegisteredItems} popup ref={el => this.nonRegisteredMenu = el} id="overlay_tmenu" onMouseLeave={(target) => this.nonRegisteredMenu.hide(target)} style={{width: "250px", marginTop: "15px", fontSize: "13px", fontWeight: "600", lineHeight: "2em"}} />
                        :
                        null
                }
                {
                    !isMobileOnly && !isTablet && this.props.userId !== null && this.props.associate !== null && this.props.internal ?
                        <TieredMenu model={internalItems} popup ref={el => this.internalMenu = el} id="overlay_tmenu" onMouseLeave={(target) => this.internalMenu.hide(target)} style={{width: "250px", marginTop: "15px", fontSize: "13px", fontWeight: "600", lineHeight: "2em"}} />
                        :
                        null
                }
                {
                    (isTablet || isMobileOnly) ?
                    this.props.userId !== null && this.props.associate !== null && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED ?
                            <SlideMenu model={this.props.registrationApproved ? this.getMobileMemberAreaMenus() : this.getNonApprovedMobileItems()} popup ref={el => this.mobileMenu = el} id="mobile_overlay_tmenu" backLabel={this.props.t("general.back")}/>
                            : null
                        : null
                }
                {   
                    this.props.userId !== null && this.props.associate !== null && this.props.internal ?
                    <>
                        {
                            !isMobileOnly && !isTablet ?
                            <>
                                <div className="col-1"></div>
                                <div className="col-2 t-align-left">
                                    <Link to={process.env.PUBLIC_URL + "/dashboard"} style={{maxWidth: "100%", height: "100%"}}>
                                        <img style={{maxWidth: "100%", height: "60px"}} src={process.env.PUBLIC_URL + '/assets/ordem-fisioterapeutas-logo.png'} alt="logo"/>
                                    </Link>
                                </div>
                                <div className="col-8 t-align-right">
                                    
                                        <span className='menu-option c-pointer' onClick={(event) => this.internalMenu.toggle(event)} onMouseOver={(event) => this.menu.toggle(event)} aria-haspopup aria-controls="overlay_tmenu">{this.props.t("general.menu").toUpperCase()}<img className="mgl-10" style={{color: "#0073aa"}} width={"12px"} height={"12px"} src={CaretDownIcon} /></span>
                                        <Link to={process.env.PUBLIC_URL + "/support"}>
                                            <i className="pi pi-question-circle c-pointer mgl-20 mgr-10" style={{ fontSize: '1.9rem' }} title={this.props.t("support.menu")}></i>
                                        </Link>
                                    
                                </div>
                                <div className="col-1"></div>
                            </>
                            : 
                            <>
                                <div className="col-1"></div>
                                <div className="col-4 t-align-left">
                                    <Link to={process.env.PUBLIC_URL + "/dashboard"} style={{maxWidth: "100%", height: "100%"}}>
                                        <img style={{maxWidth: "100%", height: "40px"}} src={process.env.PUBLIC_URL + '/assets/ordem-fisioterapeutas-logo.png'} alt="logo"/>
                                    </Link>
                                </div>
                                <div className="col-6 t-align-right mgr-10">
                                    <i className="pi pi-align-justify" style={{'fontSize': '1.5em'}} onClick={(event) => this.mobileInternalMenu.toggle(event)} aria-haspopup aria-controls="mobile_internal_overlay_tmenu"></i>
                                </div>
                                <div className="col-1"></div>
                            </>
                        }
                        {
                            this.props.associate !== null && (isTablet || isMobileOnly) ?
                                <SlideMenu model={internalItems} popup ref={el => this.mobileInternalMenu = el} id="mobile_internal_overlay_tmenu" backLabel={this.props.t("general.back")}/>
                                : null
                        }
                    </>
                    : 
                    <>
                        {
                            (isTablet || isMobileOnly) ?
                                <>
                                    <div className="col-1"></div>
                                    <div className="col-4 t-align-left">
                                        <img style={{maxWidth: "100%", height: "40px"}} src={process.env.PUBLIC_URL + '/assets/ordem-fisioterapeutas-logo.png'} alt="logo" onClick={() => this.renderWebsitePage(process.env.REACT_APP_OF_SITE_URL + "?hideinar=true")}/>
                                    </div>
                                    <div className="col-6 t-align-right mgr-10">
                                        {
                                            this.props.userId !== null && this.props.associate !== null && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED ?
                                                <i className="pi pi-align-justify" style={{'fontSize': '1.5em'}} onClick={(event) => this.mobileMenu.toggle(event)} aria-haspopup aria-controls="mobile_overlay_tmenu"></i>
                                                :
                                                <Link to={process.env.PUBLIC_URL + "/support"}>
                                                    <span className='menu-option c-pointer'>{this.props.t("support.menu").toUpperCase()}</span>
                                                </Link>
                                        }

                                    </div>
                                    <div className="col-1"></div>
                                </>
                                : null
                        }
                        {
                            /*!isMobileOnly && !isTablet && this.props.registrationState !== null && !this.props.registrationApproved && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED ?
                                <TieredMenu model={registrationItems} popup ref={el => this.registrationMenu = el} id="overlay_tmenu" style={{width: "250px", marginTop: "15px", fontSize: "13px", fontWeight: "600", lineHeight: "2em"}} />
                                :
                                null*/
                        }
                        {
                            !isMobileOnly && !isTablet ?
                            <>
                                <div className="col-1"></div>
                                <div className="col-2 t-align-left">
                                    <img className='c-pointer' style={{maxWidth: "100%", height: "60px"}} src={process.env.PUBLIC_URL + '/assets/ordem-fisioterapeutas-logo.png'} alt="logo" onClick={() => this.renderWebsitePage(process.env.REACT_APP_OF_SITE_URL + "?hideinar=true")}/>
                                </div>
                                <div className="col-8 t-align-right">
                                    {
                                        this.props.menus && this.props.menus.map((menu) => { 
                                            return menu.items && menu.items.length > 0 ? 
                                                    <span className='menu-option c-pointer' 
                                                        onClick={(event) => menu.ref.toggle(event)} onMouseEnter={(target) => this.clearMenus(target, menu.id)} onMouseOver={(event) => menu.ref.toggle(event)} 
                                                        aria-haspopup aria-controls={"overlay_tmenu-" + menu.id}>
                                                            {menu.title}
                                                            <img className="mgl-10" style={{color: "#0073aa"}} width={"12px"} height={"12px"} src={CaretDownIcon} />
                                                    </span>
                                                    :
                                                    <span className='menu-option c-pointer' onClick={(event) => this.renderWebsitePage(menu.itemUrl)}>
                                                        {menu.title}
                                                    </span>;
                                        })
                                    }
                                    {
                                        this.props.userId !== null && this.props.associate !== null && this.props.registrationApproved && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED ?
                                            <span className='menu-option c-pointer' onClick={(event) => this.menu.toggle(event)} onMouseEnter={(target) => this.clearMenus(target, 0)} onMouseOver={(event) => this.menu.toggle(event)} aria-haspopup aria-controls="overlay_tmenu">{this.props.t("general.menu").toUpperCase()}<img className="mgl-10" style={{color: "#0073aa"}} width={"12px"} height={"12px"} src={CaretDownIcon} /></span>
                                            : null
                                    }
                                    {
                                        this.props.userId !== null && this.props.associate !== null && !this.props.registrationApproved && this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED ?
                                            <span className='menu-option c-pointer' onClick={(event) => this.nonRegisteredMenu.toggle(event)} aria-haspopup aria-controls="overlay_tmenu">{this.props.t("general.registration").toUpperCase()}</span>
                                            : null
                                    }
                                    {
                                        /*
                                        !this.props.registrationApproved ? 
                                            <Link to={process.env.PUBLIC_URL + "/registration-form"}>
                                                <span className='menu-option c-pointer'>{this.props.t("registration-form.menu").toUpperCase()}</span>
                                            </Link>
                                            : null*/
                                    }
                                    { 
                                        this.props.userId !== null && this.props.associate !== null && this.props.hasSignatureCredits && this.props.registrationApproved && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED ?
                                            <i className="pi pi-file-edit c-pointer mgr-10" style={{ color: "#0073aa", fontSize: '1.9rem' }} title={this.props.t("signature-credits.menu")} onClick={(event) => this.accessSignaturePlatform()}></i>
                                            : null
                                    }
                                    {
                                        this.props.userId === null ?
                                            <Link to={process.env.PUBLIC_URL + "/products-public"}>
                                                <span className='menu-option'>{this.props.t("products.menu").toUpperCase()}</span>
                                            </Link>
                                            : null
                                    }
                                    {
                                        this.props.userId === null || (this.props.associate !== null && this.props.registrationApproved && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED) ?
                                        <Link to={process.env.PUBLIC_URL + "/checkout"}>
                                        {
                                            this.props.basketProducts === undefined || this.props.basketTrainings === undefined || (this.props.basketProducts.length === 0 && this.props.basketTrainings.length === 0) ?
                                                <i className="pi pi-shopping-cart c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("checkout.menu")}></i>
                                                :
                                                <i className="pi pi-shopping-cart p-overlay-badge c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("checkout.menu")}>
                                                    <Badge value={this.getTotalBasketItems()}></Badge>
                                                </i>
                                        }
                                        </Link>
                                        : null
                                    }
                                    {
                                        this.props.associate !== null && this.props.registrationState === REGISTRATION_STATE_SUSPENDED ?
                                            <Link to={process.env.PUBLIC_URL + "/support"}>
                                                <span className='menu-option c-pointer'>
                                                    {this.props.t("support.menu").toUpperCase()}
                                                </span>                                            
                                            </Link>
                                            : null
                                    }
                                </div>
                                <div className="col-1"></div>
                                <Toast position='bottom-left' ref={this._toast} />
                            </>
                        : null
                        }
                    </>
                }
            </div>
            : null
    );
  }
}

const mapStateToProps = (state) => {
    return {
        registrationApproved: state.authentication.registrationApproved,
        registrationState: state.authentication.registrationState,
        organicUnits: state.authentication.organicUnits,
        userId: state.authentication.userId,
        brainAnswerAccess: state.authentication.brainAnswerAccess,
        hasSignatureCredits: state.authentication.hasSignatureCredits,
        internal: state.authentication.internal,
        associate: state.profile.associate,
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings,
        ballot: state.profile.ballot,
        menus: state.app.menus,
        language: state.profile.language
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        renderWebsitePage: (url) => { dispatch(renderWebsitePage(url)) },
        setWebsiteMenus: (menus) => { dispatch(setWebsiteMenus(menus)) }
    }
};
  
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(MenuHeader));